import { useEffect, useRef } from 'react';
import { syncCustomersFromOrders } from '@/integrations/supabase/customers';

/**
 * Hook para sincronizar clientes de pedidos antigos automaticamente
 * Executa apenas 1 vez por sessão (usa ref para rastrear)
 */
export function useSyncCustomers() {
  const syncedRef = useRef(false);

  useEffect(() => {
    // Evitar sincronizar múltiplas vezes na mesma sessão
    if (syncedRef.current) {
      return;
    }

    const runSync = async () => {
      try {
        syncedRef.current = true;
        console.log("🚀 [useSyncCustomers] Iniciando sincronização de clientes...");
        const result = await syncCustomersFromOrders();

        if (result.alreadySynced) {
          console.log("✅ Sincronização já foi executada para esta empresa");
        } else if (result.ok) {
          console.log(`✅ Sincronização concluída: ${result.created} clientes criados`);
        } else {
          console.error(`❌ Erro na sincronização: ${result.error}`);
        }
      } catch (error) {
        console.error("❌ Erro ao executar sincronização:", error);
      }
    };

    // Executar com pequeno delay para não bloquear renderização
    const timer = setTimeout(runSync, 1000);
    return () => clearTimeout(timer);
  }, []);
}
